/**
 *
 * SideListItem
 *
 */

import React, { memo, useCallback, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useParams, useLocation } from 'react-router-dom';
import Highlighter from "react-highlight-words";

// styles
import './style.scss';

// antd component
import { List } from 'antd';

// components
import {
  AbsenceListItem,
  ClassListItem,
  CommunicationListItem,
  ParentCommunicationListItem,
  CourseListItem,
  StudentListItem,
  UserListItem,
  TeacherCommunicationListItem,
} from './Items';

// utils
import { getObjId } from 'utils/helpers/helper.general';
import _local from 'utils/localStorageUtils';

function SideListItem({
  type,
  // main
  element,
  activeElement,
  searchString,
  // actions
  onClickAction,
  // default props
  className,
  id,
  ...rest
}) {

  const childClassNames = classNames(
    `schl-list-item schl-list-item__type-${type}`,
    (
      (type == 'communications-teacher' || type == 'communications-parent') &&
      !element?.read
    ) && 'not-read',
    element?.thumbnail && 'has-thumbnail', 
    className
  );
  const { id: initId } = useParams();
  const elementRef = useRef(element);

  const localUser = _local.getLocalUser();

  const [current, setCurrent] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isNotRead, setIsNotRead] = useState(false);

  useEffect(() => {
    if (getObjId(element) == getObjId(initId)) {
      setIsActive(true)
      setIsNotRead(false)
    } else {
      setIsActive(false);
      setIsNotRead(isNotReadCallback(element, activeElement))
    }
  }, [initId]);
  
  useEffect(() => {
    if (getObjId(element) == getObjId(activeElement)) {
      setCurrent(activeElement);
    }
  }, [element, activeElement]);

  const handleClick = e => {
  //  const targetId = elementRef?.current.id;
    const elId = !!id && id || !!element && getObjId(element);
    onClickAction(elId, element);
  };

  const customHighlighter = useCallback((text, searchString) => {
    return text && searchString ? (
      <Highlighter
        highlightClassName="tcf-highlighter"
        searchWords={[searchString]}
        autoEscape={true}
        textToHighlight={text?.toString()}
      />
    ) : text;
  }, [searchString]);

  const isNotReadCallback = useCallback((element, activeEl) => {
    let compareEl = element;
    switch (type) {
      case 'communications':
        if (activeEl?.readership) {
          compareEl = {
            ...compareEl,
            readership: activeEl?.readership
          }
        }
        const readership = compareEl?.readership?.filter(el => (
          (getObjId(el?.user) == getObjId(localUser?._id))
        ));
        const notHasRead = !compareEl?.readership;
        const hasReadNotRead = compareEl?.readership?.length == 0;
        return compareEl?.status == 'sent' && (!!notHasRead || !!hasReadNotRead);
      case 'communications-teacher':
      case 'communications-parent':
        return !compareEl?.read;
      default:
        return false;
    }
  }, [type, localUser?._id])

  const metaByType = useCallback((itemsOptions) => {
    switch (type) {
      case 'utilisateurs':
        return <UserListItem activeEl={current} {...itemsOptions} />;
      case 'classes':
        return <ClassListItem activeEl={current} {...itemsOptions} />;
      case 'сours':
        return <CourseListItem activeEl={current} {...itemsOptions} />;
      case 'etudiants':
        return <StudentListItem activeEl={current} {...itemsOptions} />;
      case 'absence':
        return <AbsenceListItem activeEl={current} {...itemsOptions} />;
      case 'communications':
        return <CommunicationListItem activeEl={current} {...itemsOptions} />;
      case 'communications-teacher':
        return <TeacherCommunicationListItem activeEl={current} {...itemsOptions} />;
      case 'communications-parent':
        return <ParentCommunicationListItem activeEl={current} {...itemsOptions} />;
    }
  }, [current]);

  return (
    element && (
      <List.Item
        id={id || element._id}
        className={classNames(
          childClassNames,
          isActive ? `active` : '',
          isNotRead ? `not-read` : '',
        )}
        onClick={handleClick}
        {...rest}
        ref={elementRef}
      >
        {metaByType({
          element,
          customHighlighter,
          searchString,
          active: getObjId(element) == getObjId(initId) == getObjId(current) && initId
        })}
      </List.Item>
    )
  );
}

SideListItem.defaultProps = {
  searchString: '',
};
SideListItem.propTypes = {
  type: PropTypes.oneOf(['utilisateurs', 'classes', 'сours', 'etudiants', 'absence', 'communications', 'communications-parent', 'communications-teacher'])
    .isRequired,
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  onClickAction: PropTypes.func,
};

export default memo(SideListItem);
